const PLANS_COLORS = ['#5073F0', '#923FDB', '#4B4AC6']
const UNLIMITED_ITEM_LIMIT = 2000000000

export {
  PLANS_COLORS,
  UNLIMITED_ITEM_LIMIT
}
